import { get, patch, post } from '../client/client';
import { endpoint } from '../endpoint';
import type { UserCreate, UserPublic, UserUpdate } from '../type/user';

export const getUsers = async () => {
  return await get<UserPublic[]>(endpoint.getUsers);
};

export const createUser = async (payload: UserCreate) => {
  return await post<UserPublic, UserCreate>(endpoint.createUser, payload);
};

export const updateUser = async (userId: number, payload: UserUpdate) => {
  return await patch<UserPublic, UserUpdate>(endpoint.updateUser(userId), payload);
};
